<div class="login-bg">
  <div class="row w-100 align-items-center">
    <div class="col-lg-6 d-flex">
      <div class="auth-logo m-auto">
        <img src="assets/images/admin-logo-v2.png" class="img-fluid" alt="" />
      </div>
    </div>
    <div class="col-lg-6">
      <div class="splash-container login-wrap d-flex align-items-center">
        <div class="card px-2 py-5 mb-0">
          <div class="card-body">
            <div class="headbox text-center">
              <h1>Change Passwords</h1>
              <span class="splash-description">Please enter your new password</span>
            </div> 
            <div class="middle-area">
              <form [formGroup]="passwordForm">
              <div class="form-group mb-4 text-center">
                <!-- <input type="number"  class="form-control" formControlName="otp" placeholder="Enter otp"
                  required> -->
                  <ng-otp-input (onInputChange)="getOtp($event)" [config]="{length:4}"></ng-otp-input>
              </div>
              <div class="d-flex flex-column align-items-center my-5">
             
                <label style="text-align: center;">Time Left: <span style="font-size: larger; font-weight: bold;">{{ timeLeft }}</span></label>
                <label class="d-inline-block" *ngIf="isTimerExpired()">Not Received Yet? <a href="javascript:void(0);" (click)="sendOtp()" class="red-link">Send Again</a></label>
              </div>
              <div class="form-group position-relative">
                <input type="{{pwdType ? 'password' : 'text'}}" formControlName="new_password" class="form-control form-control-lg"
                  placeholder="New Password" />
                <div class="eye-icon" (click)="togglePwdType()" style="cursor: pointer;">
                  <span class="material-symbols-sharp">{{pwdType ? 'visibility_off' : 'visibility'}}</span>
                </div>
                <div
                  *ngIf="passwordForm.get('new_password')?.hasError('required') && passwordForm.get('new_password')?.touched"
                  class="error-message">Password is required</div>
                <div
                  *ngIf="passwordForm.get('new_password')?.hasError('minlength') && passwordForm.get('new_password')?.touched"
                  class="error-message">Password should be at least 8 characters</div>
              </div>
              <div class="form-group">
                <input type="password" class="form-control form-control-lg" formControlName="confirm_password" placeholder="Confirm Password"
                  required>
              </div>
              <div class="btn-wrap text-center mt-5">
                <button type="submit" class="btn btn-lg btn-block btn-primary" (click)="onSubmit()">Submit</button>
              </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>